import { GetDocumentListEmdResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetDocumentListEmdModel } from './get-document-list-emd.state';

/** StateDetailsActions */
const ACTION_SET = '[GetDocumentListEmd] set';
const ACTION_UPDATE = '[GetDocumentListEmd] update';
const ACTION_RESET = '[GetDocumentListEmd] reset';
const ACTION_FAIL = '[GetDocumentListEmd] fail';
const ACTION_CANCEL_REQUEST = '[GetDocumentListEmd] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetDocumentListEmd] set from api';
const ACTION_UPDATE_FROM_API = '[GetDocumentListEmd] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetDocumentListEmd = createAction(ACTION_SET, props<WithRequestId<GetDocumentListEmdModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetDocumentListEmd = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<GetDocumentListEmdModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetDocumentListEmd = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetDocumentListEmdRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetDocumentListEmd = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetDocumentListEmdFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<GetDocumentListEmdResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetDocumentListEmdFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<GetDocumentListEmdResponse>>()
);
